import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";

const DiversionVillaCarlosPazPri = ({ hasBg = true }) => {
  return (
    <>
      <section
        id="diversion"
        className={`screenshots-section ptb-100 ${
          hasBg ? "gray-light-bg" : ""
        }`}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="section-heading text-center">
                {hasBg ? (
                  <span className="text-uppercase color-secondary sub-title">
                    Sierras, momentos unicos y mas
                  </span>
                ) : (
                  ""
                )}
                <h2>¡Descubre lo mejor de Villa Carlos Paz con nuestro viaje de egresaditos!</h2>
                <p className="lead">
                Montañas, sierras, ríos y los paisajes más hermosos de Córdoba te esperan. Hemos preparado un viaje de egresaditos distintivo para crear recuerdos inolvidables.
                </p>
              </div>
            </div>
          </div>
          <Swiper
            // install Swiper modules
            modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
            centeredSlides={true}
            spaceBetween={50}
            slidesPerView={1}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            loop={true}
            pagination={{ clickable: true }}
            onSwiper={(swiper) => console.log(swiper)}
          >
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazPri/diversion/imagenescordoba1.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazPri/diversion/imagenescordoba2.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazPri/diversion/imagenescordoba3.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazPri/diversion/imagenescordoba4.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazPri/diversion/imagenescordoba5.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazPri/diversion/imagenescordoba6.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazPri/diversion/imagenescordoba7.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazPri/diversion/imagenescordoba8.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazPri/diversion/imagenescordoba9.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default DiversionVillaCarlosPazPri;
